import { BaseService } from "@kiddocare-platform/portal-common/base";


export class RepositoryAvatarsService extends BaseService {
  
  public async avatarGetByKey(key: string): Promise<Blob> {
    try {
      const response = await this.AxiosInstance.get(`/parent/avatars/getByKey/${key}`, {
        responseType: 'blob'
      });
      return response.data;
    }
    catch (error: any) {
      throw error
    }
  }
  
  public async uploadPersonalAvatar(blob: Blob): Promise<any> {
    try {
      const formData = new FormData();
      formData.append("avatar", blob);
      const response = await this.AxiosInstance.post('/parent/avatars/personal', formData, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "multipart/form-data"
        }
      });

      return response.data; // Restituisce la risposta del server
    } catch (error: any) {
      throw error;
    }
  }

  public async uploadPatientAvatar(idPatient: bigint | number, blob: Blob): Promise<any> {
    try {
      const formData = new FormData();
      formData.append("avatar", blob);
      const response = await this.AxiosInstance.post(`/parent/avatars/patient/${idPatient}`, formData, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "multipart/form-data"
        }
      });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

}
